import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import Salary from "../../../../pages/Profile/Documentation/Salary";
import { DocumentsPagesContainerProps } from "../../../../interfaces/containers";
import { editUserRequest, cleanEditUser } from "../../../../actions/auth";
import { getIsValidDocuments } from "../../../../actions/documents";

function mapStateToProps(state: DocumentsPagesContainerProps) {
    return{
        salary: state.documents.documents.salary_settlements,
        user: state.auth.user,
        fetchingEdit: state.auth.fetchingEdit,
        types: state.documents.types
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        editUserRequest,
        cleanEditUser,
        getIsValidDocuments
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Salary);